import React, { Component } from "react";
import Card from "../Card";
import s from "./CardList.module.scss";
import { Input, Form, Button } from "antd";
import HomePage from "../../pages/Home";
import getTranslateWord from "../../services/dictionary";

const { Search } = Input;

class CardList extends Component {
	state = {
		value: "",
		label: "",
		isBusy: false,
	};

	formRef = React.createRef();
	inputEngRef = React.createRef();

	constructor(props) {
		super(props)

		props.refEngInput && props.refEngInput(this.inputEngRef);
	}

	handleSubmitForm = (values) => {
		const { onSubmit } = this.props;
		console.log('####" values', values);

		onSubmit && onSubmit(values);
		this.formRef.current.resetFields();
	};

	// handleInputChange = (e) => {
	// 	console.log(e.target.value);
	// 	this.setState({
	// 		value: e.target.value,
	// 	});
	// }

	// getTheWord = async () => {
	// 	const { value } = this.state;
	// 	const getWord = await getTranslateWord(this.state.value);
	// 	console.log('####: ', getWord)
	// 	this.setState({ 
	// 		label: `${value} - ${getWord.translate}`,
	// 		value: "",
	// 		isBusy: false,
	// 	});
	// }






	renderWordForm = () => {
		return (
			<div className={s.form}>
				<Form
					className={s.form_wrap}
					ref={this.formRef}
					name="basic"
					layout="inline"
					onFinish={this.handleSubmitForm}
				>
					<Form.Item
						label="English Word"
						name="eng"
					>
						<Input
							ref={this.inputEngRef}
							placeholder="input placeholder"
						/>
					</Form.Item>
					<Form.Item
						label="Русское слово"
						name="rus"
					>
						<Input placeholder="input placeholder"/>
					</Form.Item>
					<Form.Item>
						<Button
							type="primary"
							htmlType="submit"
						>Добавить</Button>
					</Form.Item>
				</Form>

			</div>
		);
	}
	render() {
		const { item = [], onDeletedItem } = this.props;
		const { value, label, isBusy } = this.state;
		return (
			<>
				{ this.renderWordForm() }


				<div className={s.root}>
					{item.map(({ eng, rus, id }) => (
						<Card
							className={s.card}
							onDeleted={() => {
								console.log("####: 2 level");
								onDeletedItem(id);
							}}
							key={id}
							eng={eng}
							rus={rus}
						/>
					))}
				</div>
			</>
		);
	}
}

export default CardList;
